import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import {
  ACCOUNT_USER_RANK_FILTER_OPTION_MODEL,
  ACCOUNT_USER_RANK_SORT_OPTION_MODEL,
} from '../../../../../store/modules/account/user/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';

const AccountUserRankList = (props) => {
  const { accountUserRankList, getList, getExcelDownload } = props;
  const { list, filterOption, sortOption, pagination, summary } = accountUserRankList;

  return (
    <div className="account-user-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: ACCOUNT_USER_RANK_FILTER_OPTION_MODEL,
          sortOption: ACCOUNT_USER_RANK_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={ACCOUNT_USER_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default AccountUserRankList;
